/*
 *
 * UserManagement reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_USERS_WATCHER,
  GET_USERS_SUCCESS,
  GET_USERS_FAILED,
  SWITCH_USER_WATCHER,
} from "./constants"

export const initialState = fromJS({
  listUsers: [],
  isLoadingListUsers: true,
  genders: [],
  isLoadingGenders: true,
})

function userManagementReducer(state = initialState, action) {
  switch (action.type) {
    case GET_USERS_WATCHER:
    case SWITCH_USER_WATCHER:
      return (
        state
          // .set('listUsers', [])
          .set("isLoadingListUsers", true)
      )
    case GET_USERS_SUCCESS:
      return state
        .set("listUsers", action.payload)
        .set("isLoadingListUsers", false)
    case GET_USERS_FAILED:
      return (
        state
          // .set('listUsers', [])
          .set("isLoadingListUsers", false)
      )
    default:
      return state
  }
}

export default userManagementReducer
